import { getIn } from 'seamless-immutable';

export const isSellerPage = pageType => pageType === 'lojista';

export const getSellerId = product => getIn(product, ['offers', 'result', 0, 'seller', 'id'], '');
